if (!customElements.get('zoom-dialog')) {
  class ZoomDialog extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('dialog');
      this.media = Array.from(this.querySelectorAll('.product-media-container'));
      this.thumbnails = this.querySelector('.dialog-thumbnails-list');
      this.highResImagesLoaded = new Set();

      this.handleScroll = this.debounce(this.handleScrollEvent.bind(this), 50);

      if (this.dialog) {
        this.dialog.addEventListener('scroll', this.handleScroll);
      }

      /* Oieffur 2026-10-07 第三批第 14 条：大图查看器改为左右滑动、整图显示、双击/双指放大、下滑关闭、页码 */
      this.list = this.querySelector('.dialog-zoomed-gallery');
      this.oSetup();
    }

    oSetup() {
      if (!this.dialog || !this.list) return;
      this.oIndex = 0;
      this.oZoom = null;
      this.oT = null;
      this.oLastTap = null;

      const count = document.createElement('div');
      count.className = 'o-zoom__count';
      count.setAttribute('aria-live', 'polite');
      this.oCount = count;
      this.dialog.appendChild(count);

      this.oNav = [];
      if (this.media.length > 1) {
        ['prev', 'next'].forEach((dir) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = `o-zoom__nav o-zoom__nav--${dir}`;
          b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
          b.innerHTML = dir === 'prev'
            ? '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>'
            : '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
          b.addEventListener('click', (e) => {
            e.stopPropagation();
            this.oGo(this.oIndex + (dir === 'prev' ? -1 : 1));
          });
          this.dialog.appendChild(b);
          this.oNav.push(b);
        });
      }

      this.list.addEventListener('scroll', this.debounce(() => this.oSync(), 60), { passive: true });
      /* 点图不再关闭（原来点一下就关）；电脑上点一下放大、再点还原 */
      this.list.addEventListener('click', (e) => {
        const li = e.target.closest('.product-media-container--image');
        if (!li) return;
        e.stopPropagation();
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) this.oToggleZoom(li, e.clientX, e.clientY);
      }, true);
      this.list.addEventListener('mousemove', (e) => {
        if (this.oZoom && this.oZoom.s > 1 && !this.oT) this.oPanTo(e.clientX, e.clientY);
      });
      this.list.addEventListener('touchstart', (e) => this.oTouchStart(e), { passive: false });
      this.list.addEventListener('touchmove', (e) => this.oTouchMove(e), { passive: false });
      this.list.addEventListener('touchend', (e) => this.oTouchEnd(e), { passive: false });
      this.list.addEventListener('touchcancel', (e) => this.oTouchEnd(e), { passive: false });
      this.dialog.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.oGo(this.oIndex + 1);
        if (e.key === 'ArrowLeft') this.oGo(this.oIndex - 1);
      });
      this.dialog.addEventListener('close', () => this.oResetZoom(false));
      this.oUpdateCount();
    }

    oVisible() {
      return this.media.filter((m) => m.offsetParent !== null);
    }

    oSync() {
      const items = this.oVisible();
      if (!items.length) return;
      const w = this.list.clientWidth || 1;
      const i = Math.max(0, Math.min(items.length - 1, Math.round(this.list.scrollLeft / w)));
      if (i !== this.oIndex) this.oResetZoom(false);
      this.oIndex = i;
      const mi = this.media.indexOf(items[i]);
      if (this.thumbnails) {
        Array.from(this.thumbnails.querySelectorAll('button')).forEach((button, k) => {
          button.setAttribute('aria-selected', `${k === mi}`);
        });
        const thumb = this.thumbnails.children[mi];
        if (thumb instanceof HTMLElement) {
          this.scrollIntoView(thumb, { ancestor: this.thumbnails, behavior: 'smooth', block: 'center', inline: 'center' });
        }
      }
      this.loadHighResolutionImage(items[i]);
      this.oUpdateCount();
      this.dispatchEvent(new CustomEvent('zoom-media:selected', { detail: { index: mi } }));
    }

    oUpdateCount() {
      const n = this.oVisible().length || this.media.length;
      if (!this.oCount) return;
      this.oCount.textContent = n > 1 ? `${this.oIndex + 1} / ${n}` : '';
      this.oCount.hidden = n <= 1;
      if (this.oNav && this.oNav.length) {
        this.oNav[0].disabled = this.oIndex <= 0;
        this.oNav[1].disabled = this.oIndex >= n - 1;
      }
    }

    oGo(i, behavior) {
      const items = this.oVisible();
      if (!items.length) return;
      const k = Math.max(0, Math.min(items.length - 1, i));
      const b = behavior || (this.prefersReducedMotion() ? 'auto' : 'smooth');
      this.list.scrollTo({ left: k * this.list.clientWidth, behavior: b });
      if (b === 'auto') this.oSync();
    }

    oWrap(li) {
      return li.querySelector('.product-media__drag-zoom-wrapper') || li.querySelector('.product-media') || li;
    }

    oZoomFor(li) {
      if (!this.oZoom || this.oZoom.li !== li) {
        this.oResetZoom(false);
        this.oZoom = { li, wrap: this.oWrap(li), s: 1, tx: 0, ty: 0 };
      }
      return this.oZoom;
    }

    oLimits(z) {
      const r = z.li.getBoundingClientRect();
      const img = z.li.querySelector('img');
      let dw = r.width, dh = r.height;
      if (img && img.naturalWidth && img.naturalHeight) {
        const k = Math.min(r.width / img.naturalWidth, r.height / img.naturalHeight);
        dw = img.naturalWidth * k;
        dh = img.naturalHeight * k;
      }
      return { r, mx: Math.max(0, (dw * z.s - r.width) / 2), my: Math.max(0, (dh * z.s - r.height) / 2) };
    }

    oClamp(z) {
      const { mx, my } = this.oLimits(z);
      z.tx = Math.max(-mx, Math.min(mx, z.tx));
      z.ty = Math.max(-my, Math.min(my, z.ty));
    }

    oApply(z, animate) {
      z.wrap.style.transition = animate ? '' : 'none';
      z.wrap.style.transform = z.s > 1 ? `translate(${z.tx}px, ${z.ty}px) scale(${z.s})` : '';
      z.li.classList.toggle('is-zoomed', z.s > 1);
    }

    oResetZoom(animate = true) {
      const z = this.oZoom;
      if (!z) return;
      z.s = 1; z.tx = 0; z.ty = 0;
      this.oApply(z, animate);
    }

    oToggleZoom(li, x, y) {
      const z = this.oZoomFor(li);
      if (z.s > 1) { this.oResetZoom(true); return; }
      const r = li.getBoundingClientRect();
      z.s = 2.5;
      z.tx = -(x - (r.left + r.width / 2)) * (z.s - 1);
      z.ty = -(y - (r.top + r.height / 2)) * (z.s - 1);
      this.oClamp(z);
      this.oApply(z, true);
    }

    oPanTo(x, y) {
      const z = this.oZoom;
      const { r, mx, my } = this.oLimits(z);
      z.tx = -((x - (r.left + r.width / 2)) / (r.width / 2)) * mx;
      z.ty = -((y - (r.top + r.height / 2)) / (r.height / 2)) * my;
      this.oClamp(z);
      this.oApply(z, false);
    }

    oTouchStart(e) {
      const li = e.target.closest('.product-media-container--image');
      if (!li) return;
      const t = e.touches;
      const z = this.oZoomFor(li);
      this.oT = { li, z, x0: t[0].clientX, y0: t[0].clientY, tx0: z.tx, ty0: z.ty, s0: z.s, t0: Date.now(), moved: false, mode: null, dy: 0 };
      if (t.length === 2) {
        this.oT.mode = 'pinch';
        this.oT.d0 = Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY) || 1;
        e.preventDefault();
      }
    }

    oTouchMove(e) {
      const T = this.oT;
      if (!T) return;
      const t = e.touches;
      if (t.length === 2) {
        if (T.mode !== 'pinch') {
          T.mode = 'pinch';
          T.d0 = Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY) || 1;
          T.s0 = T.z.s; T.tx0 = T.z.tx; T.ty0 = T.z.ty;
        }
        e.preventDefault();
        const d = Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
        const s = Math.max(1, Math.min(4, (T.s0 * d) / T.d0));
        T.z.tx = (T.tx0 * s) / T.s0;
        T.z.ty = (T.ty0 * s) / T.s0;
        T.z.s = s;
        this.oClamp(T.z);
        this.oApply(T.z, false);
        T.moved = true;
        return;
      }
      const dx = t[0].clientX - T.x0;
      const dy = t[0].clientY - T.y0;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) T.moved = true;
      if (T.z.s > 1) {
        e.preventDefault();
        T.mode = 'pan';
        T.z.tx = T.tx0 + dx;
        T.z.ty = T.ty0 + dy;
        this.oClamp(T.z);
        this.oApply(T.z, false);
        return;
      }
      if (T.mode === null && T.moved) T.mode = dy > 0 && Math.abs(dy) > Math.abs(dx) ? 'down' : 'x';
      if (T.mode === 'down') {
        e.preventDefault();
        T.dy = Math.max(0, dy);
        T.z.wrap.style.transition = 'none';
        T.z.wrap.style.transform = `translateY(${T.dy}px)`;
      }
    }

    oTouchEnd(e) {
      const T = this.oT;
      if (!T) return;
      if (e.touches && e.touches.length) {
        if (T.mode === 'pinch') {
          T.mode = 'pan';
          T.x0 = e.touches[0].clientX; T.y0 = e.touches[0].clientY;
          T.tx0 = T.z.tx; T.ty0 = T.z.ty;
        }
        return;
      }
      this.oT = null;
      if (T.mode === 'down') {
        if (T.dy > 100) {
          this.closeDialog();
          T.z.wrap.style.transform = '';
        } else {
          this.oApply(T.z, true);
        }
        return;
      }
      if (T.mode === 'pinch' || T.mode === 'pan') {
        if (T.z.s < 1.05) this.oResetZoom(true);
        return;
      }
      if (!T.moved && Date.now() - T.t0 < 300) {
        const now = Date.now();
        if (this.oLastTap && now - this.oLastTap.t < 320 && this.oLastTap.li === T.li) {
          e.preventDefault();
          this.oToggleZoom(T.li, T.x0, T.y0);
          this.oLastTap = null;
        } else {
          this.oLastTap = { t: now, li: T.li };
        }
      }
    }

    connectedCallback() {
      this.querySelectorAll('[data-zoom-index]').forEach(trigger => {
        trigger.addEventListener('click', e => {
          const index = Number(trigger.dataset.zoomIndex);

          this.open(index, e);
        });
      });
    }

    disconnectedCallback() {
      if (this.dialog) {
        this.dialog.removeEventListener('scroll', this.handleScroll);
      }
    }

    async open(index, event) {
      event.preventDefault();

      const targetImage = this.media[index];
      const targetThumbnail = this.thumbnails?.children[index];

      const openDialog = () => {
        if (this.dialog.showModal) {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }

        this.oIndex = Math.max(0, this.oVisible().indexOf(targetImage));
        this.oGo(this.oIndex, 'auto');
      };

      const sourceImage = event.target instanceof Element ? event.target.closest('li,slideshow-slide') : null;

      if (!this.supportsViewTransitions() || !sourceImage || !targetImage) {
        openDialog();
        this.selectThumbnail(index, { behavior: 'auto' });
        return;
      }

      const transitionName = `gallery-item`;
      sourceImage.style.setProperty('view-transition-name', transitionName);

      await this.startViewTransition(() => {
        openDialog();
        sourceImage.style.removeProperty('view-transition-name');
        targetImage.style.setProperty('view-transition-name', transitionName);
      });

      targetImage.style.removeProperty('view-transition-name');
      this.selectThumbnail(index, { behavior: 'auto' });
    }

    closeDialog() {
      if (this.dialog.close) {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
      }
      window.dispatchEvent(new CustomEvent('dialog-close'));
    }

    async close() {
      if (!this.supportsViewTransitions()) return this.closeDialog();

      const mostVisibleElement = await this.getMostVisibleElement(this.media);
      const activeIndex = this.media.indexOf(mostVisibleElement);
      const transitionName = `gallery-item`;

      const mediaGallery = this.closest('media-gallery');
      const slideshowActive = mediaGallery?.presentation === 'carousel';
      const slide = slideshowActive ? mediaGallery.slideshow?.slides?.[activeIndex] : mediaGallery?.media?.[activeIndex];

      if (!slide) return this.closeDialog();

      this.dialog.classList.add('dialog--closed');
      await this.onAnimationEnd(this.thumbnails);

      mostVisibleElement.style.setProperty('view-transition-name', transitionName);

      await this.startViewTransition(() => {
        mostVisibleElement.style.removeProperty('view-transition-name');
        slide.style.setProperty('view-transition-name', transitionName);
        this.closeDialog();
      });

      slide.style.removeProperty('view-transition-name');
      this.dialog.classList.remove('dialog--closed');
    }

    async handleScrollEvent() {
      const mostVisibleElement = await this.getMostVisibleElement(this.media);
      const activeIndex = this.media.indexOf(mostVisibleElement);
      const targetThumbnail = this.thumbnails?.children[activeIndex];

      if (!targetThumbnail || !(targetThumbnail instanceof HTMLElement)) return;

      Array.from(this.thumbnails.querySelectorAll('button')).forEach((button, i) => {
        button.setAttribute('aria-selected', `${i === activeIndex}`);
      });

      this.loadHighResolutionImage(mostVisibleElement);
      this.dispatchEvent(new CustomEvent('zoom-media:selected', { detail: { index: activeIndex } }));
    }

    async handleThumbnailClick(index) {
      const behavior = this.prefersReducedMotion() ? 'auto' : 'smooth';
      this.selectThumbnail(index, { behavior });
    }

    async selectThumbnail(index, options = { behavior: 'smooth' }) {
      if (!this.thumbnails || !this.thumbnails.children.length) return;
      if (isNaN(index) || index < 0 || index >= this.thumbnails.children.length) return;

      const targetThumbnail = this.thumbnails.children[index];
      if (!targetThumbnail || !(targetThumbnail instanceof HTMLElement)) return;

      Array.from(this.thumbnails.querySelectorAll('button')).forEach((button, i) => {
        button.setAttribute('aria-selected', `${i === index}`);
      });

      this.scrollIntoView(targetThumbnail, {
        ancestor: this.thumbnails,
        behavior: options.behavior,
        block: 'center',
        inline: 'center',
      });

      const targetImage = this.media[index];

      if (targetImage) {
        const vis = this.oVisible ? this.oVisible() : [];
        const vi = vis.indexOf(targetImage);
        if (this.list && vi > -1 && this.list.scrollWidth > this.list.clientWidth) {
          this.oGo(vi, options.behavior === 'smooth' ? 'smooth' : 'auto');
        } else {
          targetImage.scrollIntoView({
            behavior: options.behavior,
          });
        }

        this.loadHighResolutionImage(targetImage);
      }

      this.dispatchEvent(new CustomEvent('zoom-media-selected', { detail: { index } }));
    }

    loadHighResolutionImage(mediaContainer) {
      if (!mediaContainer.classList.contains('product-media-container--image')) return false;

      const image = mediaContainer.querySelector('img.product-media__image');
      if (!image || !(image instanceof HTMLImageElement)) return false;

      const highResolutionUrl = image.getAttribute('data_max_resolution');
      if (!highResolutionUrl || this.highResImagesLoaded.has(highResolutionUrl)) return false;

      this.preloadImage(highResolutionUrl);

      const newImage = new Image();
      newImage.className = image.className;
      newImage.alt = image.alt;
      newImage.setAttribute('data_max_resolution', highResolutionUrl);

      newImage.onload = () => {
        image.replaceWith(newImage);
        this.highResImagesLoaded.add(highResolutionUrl);
      };

      newImage.src = highResolutionUrl;
    }

    getMostVisibleElement(elements) {
      return new Promise((resolve) => {
        const observer = new IntersectionObserver(
          (entries) => {
            const mostVisible = entries.reduce((prev, current) =>
              current.intersectionRatio > prev.intersectionRatio ? current : prev
            );
            observer.disconnect();
            resolve(mostVisible.target);
          },
          { threshold: [0, 0.5, 1] }
        );
        for (const element of elements) {
          observer.observe(element);
        }
      });
    }

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    supportsViewTransitions() {
      return 'startViewTransition' in document;
    }

    async startViewTransition(callback) {
      if (this.supportsViewTransitions()) {
        return document.startViewTransition(callback);
      } else {
        callback();
      }
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    preloadImage(src) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = src;
      document.head.appendChild(link);
    }

    onAnimationEnd(element) {
      return new Promise((resolve) => {
        const handleAnimationEnd = () => {
          element.removeEventListener('animationend', handleAnimationEnd);
          resolve();
        };
        element.addEventListener('animationend', handleAnimationEnd);
      });
    }

    scrollIntoView(element, { ancestor, behavior = 'smooth', block = 'start', inline = 'start' } = {}) {
      if (!ancestor) {
        return element.scrollIntoView({ behavior, block, inline });
      }

      const ancestorRect = ancestor.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();

      const calculateScrollOffset = (alignment, ancestorStart, ancestorLength, elemStart, elemLength, currentScroll) => {
        switch (alignment) {
          case 'start':
            return currentScroll + elemStart - ancestorStart;
          case 'center':
            return currentScroll + elemStart - ancestorStart - ancestorLength / 2 + elemLength / 2;
          case 'end':
            return currentScroll + elemStart - ancestorStart - ancestorLength + elemLength;
          default:
            return currentScroll;
        }
      };

      const scrollTop =
        ancestor.scrollHeight > ancestor.clientHeight
          ? calculateScrollOffset(
              block,
              ancestorRect.top,
              ancestor.clientHeight,
              elementRect.top,
              elementRect.height,
              ancestor.scrollTop
          )
          : ancestor.scrollTop;

      const scrollLeft =
        ancestor.scrollWidth > ancestor.clientWidth
          ? Math.max(0, calculateScrollOffset(
              inline,
              ancestorRect.left,
              ancestor.clientWidth,
              elementRect.left,
              elementRect.width,
              ancestor.scrollLeft
            ))
          : ancestor.scrollLeft;

      ancestor.scrollTo({
        left: scrollLeft,
        top: scrollTop,
        behavior: behavior
      });
    }
  }

  if (!customElements.get('zoom-dialog')) {
    customElements.define('zoom-dialog', ZoomDialog);
  }
}

document.addEventListener('click', e => {
  const trigger = e.target.closest('[data-zoom-target]');
  if (!trigger) return;

  const targetSelector = trigger.dataset.zoomTarget;
  const zoomDialog = document.querySelector(targetSelector);
  if (!zoomDialog) return;

  const index = Number(trigger.dataset.zoomIndex);

  if (trigger.classList.contains('product-media-container--zoomable')) {
    zoomDialog.open(index, e);
  }

  if (trigger.classList.contains('dialog-thumbnails-list__thumbnail')) {
    zoomDialog.handleThumbnailClick(index);

    const swiperThumbnail = document.querySelector(`.swiper-controls__thumbnail[data-index="${index}"]`);
    if (swiperThumbnail) {
      swiperThumbnail.click();
    }
  }
});

if (!customElements.get('scroll-hint')) {
  class ScrollHint extends HTMLElement {
    connectedCallback() {
      this.addEventListener('scroll', theme.utils.rafThrottle(this.update.bind(this)));
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      this.removeEventListener('scroll', this.update);
      this.resizeObserver.disconnect();
    }

    update = () => {
      const { scrollTop, scrollHeight, clientHeight, scrollLeft, scrollWidth, clientWidth } = this;
      const scrollDirection = scrollWidth > clientWidth ? 'horizontal' : 'vertical';
      const scrollPercentage =
        scrollDirection === 'vertical'
          ? scrollTop / (scrollHeight - clientHeight)
          : scrollLeft / (scrollWidth - clientWidth);

      this.style.maskImage = Number.isNaN(scrollPercentage)
        ? ''
        : `linear-gradient(
          to ${scrollDirection === 'vertical' ? 'bottom' : 'right'},
          transparent ${scrollPercentage > 0 ? 1 : 0}%,
          black ${scrollPercentage < 0.1 ? scrollPercentage * 100 : 10}%,
          black ${scrollPercentage > 0.9 ? scrollPercentage * 100 : 90}%,
          transparent 100%
        )`;
    };

    resizeObserver = new ResizeObserver(this.update);
  }

  customElements.define('scroll-hint', ScrollHint);
}
